import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

const CycleEditDialog = ({ open, onOpenChange, formData, setFormData, handleUpdatePattern }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("planning.cycles.editTitle")}</DialogTitle>
          <DialogDescription>{t("planning.cycles.editDescription")}</DialogDescription>
        </DialogHeader>

      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label>{t("planning.cycles.name")}</Label>
          <Input
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>
        <div className="space-y-2">
          <Label>{t("planning.cycles.description")}</Label>
          <Textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows={2}
          />
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>{t("planning.scheduleManager.actions.cancel")}</Button>
        <Button onClick={handleUpdatePattern}>{t("planning.scheduleManager.actions.save")}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  );
};

export default CycleEditDialog;
